import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '@/shared/hooks-tmp/reduxToolkitHooks';
import { EnterprisePaymentRequiredModal, UpgradePlanModal } from '@/entities/pricing';
import { useHandlePaymentSuccess } from './hooks/useHandlePaymentSuccess';
import { useSubscription } from '@/shared/hooks-tmp/useSubscription';
import { useUserback } from '@userback/react';
import { useCognitoCheckUser } from '@/entities/user/settings';
import { BuyMinutesModal } from '@/features/pricing/buyMinutes';

export const BaseLayout = () => {
  const { identify } = useUserback();

  const user = useAppSelector((state) => state.user);
  const { data } = useCognitoCheckUser();

  const nameCognitoUser = data?.name;
  const cognitoId = data?.cognitoId;
  const subscription = useSubscription(user);
  const planName = subscription?.planName;

  useEffect(() => {
    if (user) {
      identify(user.id, {
        name: nameCognitoUser || user.email,
        email: user.email,
        plan: planName,
        account_id: cognitoId,
      });
    }
  }, [cognitoId, identify, nameCognitoUser, planName, user]);

  useHandlePaymentSuccess(user);

  return (
    <Suspense>
      <Outlet />
      <UpgradePlanModal />
      <EnterprisePaymentRequiredModal />
      <BuyMinutesModal />
    </Suspense>
  );
};
